import React from "react";
import Typography from "@material-ui/core/Typography";
const Customer = ({}) => {
  return (
    <React.Fragment>
      <Typography paragraph variant="h4">
        Customer
      </Typography>
      <Typography paragraph variant="h5">
        Manage customer master data for good quality service
      </Typography>
      <Typography paragraph variant="body1">
        Customer is one of the features under the Sales module to manage
        customer master data which is ready to make an order of company
        products. It contains any information regarding the contact person,
        personal or company background, and address details of each customer.
      </Typography>
      <Typography paragraph variant="h5" className="mt-5">
        How it works
      </Typography>
      <Typography paragraph variant="body1">
        The first information displayed on this feature is the Customer list. It
        is displayed like a table that contains download functions, sort,
        filter, and global search on the header area, and contains data
        navigation and refresh function on the footer area. The data column that
        appears in this table list are listed below:
      </Typography>
      <Typography paragraph variant="body1">
        <b>Customer ID</b>
        <br />
        Indicates the ID of the Customer.
      </Typography>
      <Typography paragraph variant="body1">
        <b>Customer Group</b>
        <br />
        Indicates the customer group of the Customer.
      </Typography>
      <Typography paragraph variant="body1">
        <b>Customer Name</b>
        <br />
        Indicates the full name of the Customer.
      </Typography>
      <Typography paragraph variant="body1">
        <b>Phone Number</b>
        <br />
        Indicates the contact phone number of the Customer.
      </Typography>
      <Typography paragraph variant="body1">
        <b>City</b>
        <br />
        Indicates the city location of the Customer.
      </Typography>
      <Typography paragraph variant="body1">
        Apart from the column appearing on the table list, there are more
        columns available on each row by clicking the expand button on the left
        side of each data.
      </Typography>
      <Typography paragraph variant="body1">
        Besides, there are 4 buttons that appear on each row of Customer data
        with specific conditions explained below:
      </Typography>
      <Typography paragraph variant="body1">
        <b>Whatsapp Chat Customer</b>
        <br />
        This button only appears if the Customer has a valid phone number. It is
        used to automatically redirect to WhatsApp API to send a conversation to
        the Customer.
      </Typography>
      <Typography paragraph variant="body1">
        <b>Edit Customer</b>
        <br />
        This button is used to edit the Customer data.
      </Typography>
      <Typography paragraph variant="body1">
        <b>Customer Detail</b>
        <br />
        This button is used to navigate to the Customer detail which contains
        some tabs with details below:
        <ul>
          <li>
            <b>Basic Info</b> : This tab is to display the Customer data.
          </li>
          <li>
            <b>Addresses</b> : This tab is to display the main address and
            additional addresses of Customer.
          </li>
          <li>
            <b>Contacts</b> : This tab is to display the main contact and
            additional contacts of Customer.
          </li>
          <li>
            <b>Quotations</b> : This tab is to display any Quotations related to
            the Customer.
          </li>
          <li>
            <b>Sales Orders</b> : This tab is to display any Sales Orders
            related to the Customer.
          </li>
          <li>
            <b>A/R Invoices</b> : This tab is to display any A/R Invoices
            related to the Customer.
          </li>
          <li>
            <b>A/R Payments</b> : This tab is to display any A/R Payments
            related to the Customer.
          </li>
          <li>
            <b>Pending GIs</b> : This tab is to display any Pending GIs related
            to the Customer.
          </li>
          <li>
            <b>Attachments</b> : This tab is to display any Attachments related
            to the Customer.
          </li>
          <li>
            <b>Notes</b> : This tab is to display any Notes related to the
            Customer.
          </li>
        </ul>
        When opening the Customer detail, there will be 1 button appearing on
        the top section. The button is 'Edit Customer' which is used to edit the
        Customer data.
      </Typography>
      <Typography paragraph variant="body1">
        <b>Delete Customer</b>
        <br />
        This button is used to delete the Customer data. The Customer data is
        undeletable once it have transactions.
      </Typography>
    </React.Fragment>
  );
};

export default Customer;
